import {
  LINKS_PAGE_URL,
  HOME_PAGE_URL,
  GALLERY_PAGE_URL,
  SESSIONS_PAGE_URL,
  FANSITES_PAGE_URL,
  CLIPS_PAGE_URL,
  CONTACT_PAGE_URL,
  ABOUT_PAGE_URL,
  MAILING_LIST_PAGE_URL,
  MAILING_LIST_ADMIN_PAGE_URL,
  FAQ_PAGE_URL,
} from '../constants/Routes';

export const getNavLinkItemsArray = (user) => [
  { path: HOME_PAGE_URL, label: 'Home' },
  { path: ABOUT_PAGE_URL, label: 'About Me' },
  { path: SESSIONS_PAGE_URL, label: 'Sessions' },
  // { path: FANSITES_PAGE_URL, label: 'Fansites' },
  { path: CLIPS_PAGE_URL, label: 'Clips' },
  { path: LINKS_PAGE_URL, label: 'Links' },
  { path: FAQ_PAGE_URL, label: 'FAQ' },
  { path: GALLERY_PAGE_URL, label: 'Gallery' },
  { path: MAILING_LIST_PAGE_URL, label: 'Mailing List' },
  // { path: LOCKTOBER_PAGE_URL, label: 'Locktober' },
  { path: CONTACT_PAGE_URL, label: 'Contact' },
  user?.email && (user.role === 'ADMIN' || user.role === 'DEVELOPER')
    ? { path: MAILING_LIST_ADMIN_PAGE_URL, label: 'Admin' }
    : [],
];
